{********************************************************************}
{                                                                    }
{ written by TMS Software                                            }
{            copyright (c) 2021 - 2022                               }
{            Email : info@tmssoftware.com                            }
{            Web : http://www.tmssoftware.com                        }
{                                                                    }
{ The source code is given as is. The author is not responsible      }
{ for any possible damage done due to the use of this code.          }
{ The complete source code remains property of the author and may    }
{ not be distributed, published, given or sold in any form as such.  }
{ No parts of the source code can be included in any other component }
{ or application without written authorization of the author.        }
{********************************************************************}

unit WEBLib.TMSFNCWXOCR;

{$I WEBLib.TMSFNCDefines.inc}

interface

uses
  Classes, WEBLib.Forms, SysUtils, WEBLib.Dialogs, StrUtils
  {$IFDEF FMXLIB}
  , System.UITypes, Generics.Collections
  {$ENDIF}
  {$IFDEF VCLLIB}
  , Vcl.Controls, Generics.Collections
  {$ENDIF}
  {$IFNDEF WEBLIB}
  {$IFNDEF LCLLIB}
  , System.Types, System.JSON
  {$ENDIF}
  {$IFDEF LCLLIB}
  , fpjson, Controls, fgl
  {$ENDIF}
  {$ENDIF}
  {$IFDEF WEBLIB}
  , WEBLIB.Controls, Web, WEBLIB.JSON, Generics.Collections
  {$ENDIF}
  , WEBLib.TMSFNCCommonJSFiles, WEBLib.TMSFNCWebBrowser, WEBLib.TMSFNCCustomWebComponent,  WEBLib.TMSFNCCUstomWebControl,
  WEBLib.TMSFNCGraphics, WEBLib.TMSFNCGraphicsTypes, WEBLib.TMSFNCUtils, WEBLib.TMSFNCTypes,
  WEBLib.TMSFNCCustomControl,
  WEBLib.TMSFNCWXOCR.Consts;

type
  TTMSFNCWXOCRParagraph = class;
  TTMSFNCWXOCRLine = class;
  TTMSFNCWXOCRWord = class;

  TTMSFNCWXOCRParagraphList = class(TObjectList<TTMSFNCWXOCRParagraph>);
  TTMSFNCWXOCRLineList = class(TObjectList<TTMSFNCWXOCRLine>);
  TTMSFNCWXOCRWordList = class(TObjectList<TTMSFNCWXOCRWord>);

  TTMSFNCWXOCRProgress = class(TPersistent)
  private
    FWorkerID: string;
    FJobID: string;
    FProgress: Single;
    FStatus: string;
    FUserJobID: string;
  published
    property WorkerID: string read FWorKerID write FWorkerID;
    property UserJobID: string read FUserJobID write FUserJobID;
    property JobID: string read FJobID write FJobID;
    property Progress: Single read FProgress write FProgress;
    property Status: string read FStatus write FStatus;
  end;

  TTMSFNCWXOCRBbox = class(TPersistent)
  private
    FX0: Single;
    FX1: Single;
    FY0: Single;
    FY1: Single;
  published
    property X0: Single read FX0 write FX0;
    property X1: Single read FX1 write FX1;
    property Y0: Single read FY0 write FY0;
    property Y1: Single read FY1 write FY1;
  end;

  TTMSFNCWXOCRWord = class(TPersistent)
  private
    FBbox: TTMSFNCWXOCRBbox;
    FText: string;
    FConfidence: Double;
  published
    property Bbox: TTMSFNCWXOCRBbox read FBbox write FBbox;
    property Text: string read FText write FText;
    property Confidence: Double read FConfidence write FConfidence;
  public
    constructor Create;
    destructor Destroy; override;
  end;

  TTMSFNCWXOCRLine = class(TPersistent)
  private
    FBbox: TTMSFNCWXOCRBbox;
    FText: string;
    FConfidence: Double;
    FWords: TTMSFNCWXOCRWordList;
  published
    property Bbox: TTMSFNCWXOCRBbox read FBbox write FBbox;
    property Text: string read FText write FText;
    property Confidence: Double read FConfidence write FConfidence;
    property Words: TTMSFNCWXOCRWordList read FWords write FWords;
  public
    constructor Create;
    destructor Destroy; override;
  end;

  TTMSFNCWXOCRParagraph = class(TPersistent)
  private
    FBbox: TTMSFNCWXOCRBbox;
    FText: string;
    FConfidence: Double;
    FLines: TTMSFNCWXOCRLineList;
  published
    property Bbox: TTMSFNCWXOCRBbox read FBbox write FBbox;
    property Text: string read FText write FText;
    property Confidence: Double read FConfidence write FConfidence;
    property Lines: TTMSFNCWXOCRLineList read FLines write FLines;
  public
    constructor Create;
    destructor Destroy; override;
  end;

  TTMSFNCWXOCRResult = class(TPersistent)
  private
    FID: string;
    FJobID: string;
    FText: string;
    FHocr: string;
    FTsv: string;
    FConfidence: Double;
    FParagraphs: TTMSFNCWXOCRParagraphList;
    FLines: TTMSFNCWXOCRLineList;
    FWords: TTMSFNCWXOCRWordList;
    FJSONstring: string;
  published
    property ID: string Read FID write FID;
    property JobID: string read FJobID write FJobID;
    property Text: string read FText write FText;
    property Hocr: string read FHocr write FHocr;
    property Tsv: string read FTsv write FTsv;
    property Confidence: Double read FConfidence write FConfidence;
    property Paragraphs: TTMSFNCWXOCRParagraphList read FParagraphs write FParagraphs;
    property Words: TTMSFNCWXOCRWordList read fWords write FWords;
    property Lines: TTMSFNCWXOCRLineList read FLines write FLines;
    property JSONstring: string read FJSONstring write FJSONstring;
  public
    constructor Create;
    destructor Destroy; override;
  end;

  TTMSFNCWXOCRResultList = class(TObjectList<TTMSFNCWXOCRResult>);

  TTMSFNCWXOCRFinishedEvent = procedure(Sender: TObject; Result: TTMSFNCWXOCRResult) of object;
  TTMSFNCWXOCRProgressEvent = procedure(Sender: TObject; Progress: TTMSFNCWXOCRProgress) of object;
  TTMSFNCWXOCRErrorEvent = procedure(Sender: TObject; Error: string) of object;

  TTMSFNCWXCustomOCR = class(TTMSFNCCustomWEBComponent)
  private
    FLanguage: string;
    FWorkerCount: Integer;
    FOnFinishOCR: TTMSFNCWXOCRFinishedEvent;
    FOnFinishOCRInternal: TTMSFNCWXOCRFinishedEvent;
    FOnProgressOCR: TTMSFNCWXOCRProgressEvent;
    FOnOCRError: TTMSFNCWXOCRErrorEvent;
    FOnOCRInitialized: TNotifyEvent;
    FOnOCRInitializedInternal: TNotifyEvent;
    FResultList: TTMSFNCWXOCRResultList;
    procedure SetLanguage(const Value: string);
    procedure SetWorkerCount(const Value: Integer);
    function GetResultList: TTMSFNCWXOCRResultList;
  protected
    property WorkerCount: Integer read FWorkerCount write SetWorkerCount default 5;
    property Language: string read FLanguage write SetLanguage;
    property OnFinishOCRInternal: TTMSFNCWXOCRFinishedEvent read FOnFinishOCRInternal write FOnFinishOCRInternal;
    property OnFinishOCR: TTMSFNCWXOCRFinishedEvent read FOnFinishOCR write FOnFinishOCR;
    property OnProgressOCR: TTMSFNCWXOCRProgressEvent read FOnProgressOCR write FOnProgressOCR;
    property OnOCRError: TTMSFNCWXOCRErrorEvent read FOnOCRError write FOnOCRError;
    property OnOCRInitialized: TNotifyEvent read FOnOCRInitialized write FOnOCRInitialized;
    property OnOCRInitializedInternal: TNotifyEvent read FOnOCRInitializedInternal write FOnOCRInitializedInternal;
    function GetCustomFunctions: string; override;
    function GetWaitInitCondition: string; override;
    function GetWaitInitElseStatement: string; override;
    function GetWaitInitVariables: string; override;
    function GetInstance: NativeUInt; override;
    function GetDocURL: string; override;
    procedure DoControlInitialized; override;
    procedure LoadLinks(AList: TTMSFNCCustomWEBControlLinksList); override;
    procedure CallCustomEvent(AEventData: TTMSFNCCustomWEBControlEventData); override;
    procedure Notification(AComponent: TComponent; Operation: TOperation); override;
    procedure HandleLog(const Value: string);
    procedure HandleFinished(const Value: string);
    procedure HandleError(const Value: string);
    procedure HandleInit;
    procedure ParseToWordArray(AList: TTMSFNCWXOCRWordList; const Value: TJSONArray);
    procedure ParseToLineArray(AList: TTMSFNCWXOCRLineList; const Value: TJSONArray);
    procedure ParseToParagraphArray(AList: TTMSFNCWXOCRParagraphList; const Value: TJSONArray);
  public
    property ResultList: TTMSFNCWXOCRResultList read GetResultList;
    constructor Create(AOwner: TComponent); override;
    destructor Destroy; override;
    procedure RecognizeURL(const Value, ID: string);
    procedure RecognizeFile(const Value: TTMSFNCUtilsFile; ID: string);
    procedure RecognizeBase64(const ABase64, ID: string);
    procedure RecognizeBytes(const ABytes: TBytes; ID: string);
    procedure RecognizeBitmap(const Bitmap: TTMSFNCBitmap; ID: String);
    procedure Terminate;
  end;

  {$IFNDEF LCLLIB}
  [ComponentPlatformsAttribute(TMSPlatformsWeb)]
  [FNCJSLibReferenceAttribute(TESSERACTJS)]
  {$ENDIF}
  TTMSFNCWXOCR = class(TTMSFNCWXCustomOCR)
  published
    property WorkerCount;
    property Language;
    property OnFinishOCR;
    property OnProgressOCR;
    property OnOCRError;
    property OnOCRInitialized;
  end;

implementation

uses
  WEBLib.TMSFNCWXCommon, WEBLib.TMSFNCWXOCRHelper;

{$R TMSFNCWXOCR.res}

{ TTMSFNCWXCustomOCR }

procedure TTMSFNCWXCustomOCR.CallCustomEvent(
  AEventData: TTMSFNCCustomWEBControlEventData);
begin
  inherited;

  if AEventData.EventName <> '' then
  begin
    case IndexStr(AEventData.EventName,[LOGOCR, FINISHEDOCR, ERROR, OCRINITIALIZED]) of
      0: HandleLog(AEventData.CustomData);
      1: HandleFinished(AEventData.CustomData);
      2: HandleError(AEventData.CustomData);
      3: HandleInit;
    end;
  end;
end;

constructor TTMSFNCWXCustomOCR.Create(AOwner: TComponent);
begin
  inherited;
  LocalFileAccess := True;
  Flanguage := 'eng';
  FWorkerCount := 5;
end;

procedure TTMSFNCWXCustomOCR.RecognizeFile(const Value: TTMSFNCUtilsFile; ID: string);
var
  FImage: string;
begin
  FImage := 'data:png;base64,' + TTMSFNCUtils.FileToBase64(Value);
  ExecuteJavascript(StringReplace(Format(TESSERACTWORK, [Flanguage, FImage, ID]), CONTROL_ID, GetControlID, [rfReplaceALl]));
end;

procedure TTMSFNCWXCustomOCR.RecognizeURL(const Value, ID: string);
begin
  ExecuteJavascript(StringReplace(Format(TESSERACTWORK, [Flanguage, Value, ID]), CONTROL_ID, GetControlID, [rfReplaceALl]));
end;

procedure TTMSFNCWXCustomOCR.RecognizeBase64(const ABase64, ID: string);
var
  FImage: string;
begin
  if (Pos('data:png;base64', ABase64) > 0) OR (Pos('data:jpg;base64', ABase64) > 0) OR (Pos('data:jpeg;base64', ABase64) > 0) OR (Pos('data:image/png;base64', ABase64) > 0) OR (Pos('data:image/jpg;base64', ABase64) > 0) OR (Pos('data:image/jpeg;base64', ABase64) > 0) then
    ExecuteJavascript(StringReplace(Format(TESSERACTWORK, [Flanguage, ABase64, ID]), CONTROL_ID, GetControlID, [rfReplaceALl]))
  else if Pos('data:', ABase64) > 0 then
    raise Exception.Create('File not supported')
  else
  begin
    FImage := 'data:png;base64,' + ABase64;
    ExecuteJavascript(StringReplace(Format(TESSERACTWORK, [Flanguage, FImage, ID]), CONTROL_ID, GetControlID, [rfReplaceALl]));
  end;
end;

procedure TTMSFNCWXCustomOCR.RecognizeBitmap(const Bitmap: TTMSFNCBitmap;
  ID: String);
begin
  RecognizeBase64(TTMSFNCUtils.SaveBitmapToBase64(Bitmap), ID);
end;

procedure TTMSFNCWXCustomOCR.RecognizeBytes(const ABytes: TBytes; ID: string);
begin
  RecognizeBase64(TTMSFNCUtils.Encode64(ABytes), ID);
end;

function TTMSFNCWXCustomOCR.GetCustomFunctions: string;
begin
  Result := LoadWXOCRScripts(GetControlID, GetDefaultEventDataObject);
end;

function TTMSFNCWXCustomOCR.GetDocURL: string;
begin
Result := 'https://download.tmssoftware.com/doc/tmsfncwxpack/components/ttmsfncwxocr/';
end;

function TTMSFNCWXCustomOCR.GetInstance: NativeUInt;
begin
  Result := HInstance;
end;

function TTMSFNCWXCustomOCR.GetResultList: TTMSFNCWXOCRResultList;
begin
  if not Assigned(FResultList) then
    FResultList := TTMSFNCWXOCRResultList.Create;

  Result := FResultList;
end;

procedure TTMSFNCWXCustomOCR.HandleError(const Value: string);
begin
  if Assigned(OnOCRError) then
    OnOCRError(Self, Value);
end;

procedure TTMSFNCWXCustomOCR.HandleFinished(const Value: string);
var
  j: TJSONValue;
  r: TTMSFNCWXOCRResult;
begin
  j := TTMSFNCUtils.ParseJSON(Value);
  r := TTMSFNCWXOCRResult.Create;
  try
    r.JSONstring := TTMSFNCUtils.GetJSONValueAsstring(j);
    r.ID := TTMSFNCUtils.GetJSONProp(j, 'id');
    r.Text := TTMSFNCUtils.GetJSONProp(j, 'text');
    r.Hocr := TTMSFNCUtils.GetJSONProp(j, 'hocr');
    r.Tsv := TTMSFNCUtils.GetJSONProp(j, 'hocr');
    r.Confidence := TTMSFNCUtils.GetJSONDoubleValue(j, 'confidence');
    ParseToWordArray(r.Words, TJSONArray(TTMSFNCUtils.GetJSONValue(j, 'words')));
    ParseToLineArray(r.Lines, TJSONArray(TTMSFNCUtils.GetJSONValue(j, 'lines')));
    ParseToParagraphArray(r.Paragraphs, TJSONArray(TTMSFNCUtils.GetJSONValue(j, 'paragraphs')));

    if Assigned(FOnFinishOCRInternal) then
      OnFinishOCRInternal(Self, r);

    if Assigned(FOnFinishOCR) then
      OnFinishOCR(Self, r);

    ResultList.Add(r);
  finally
    j.Free;
  end;
end;

procedure TTMSFNCWXCustomOCR.HandleInit;
begin
  if Assigned(OnOCRInitialized) then
    OnOCRInitialized(Self);
end;

procedure TTMSFNCWXCustomOCR.HandleLog(const Value: string);
var
  p: TTMSFNCWXOCRProgress;
begin
  p := TTMSFNCWXOCRProgress.Create;
  try
    p.FromJSON(Value);

    if Assigned(FOnProgressOCR) then
      FOnProgressOCR(self, p);

  finally
    p.Free;
  end;
end;

function TTMSFNCWXCustomOCR.GetWaitInitVariables: string;
begin
  Result :=  'var e = document.getElementById("' + GetControlID + '");';
end;

function TTMSFNCWXCustomOCR.GetWaitInitElseStatement: string;
begin
  Result := 'if (window.' + GetControlID + 'scheduler) return;';
end;

function TTMSFNCWXCustomOCR.GetWaitInitCondition: string;
begin
  Result := 'typeof Tesseract === "undefined" || Tesseract === null || !e';
end;

destructor TTMSFNCWXCustomOCR.Destroy;
begin
  {$IFDEF WEBLIB}
  if not Assigned(VSIDE) then
    ExecuteJavascript(StringReplace(TERMINATEOCR, CONTROL_ID, GetControlID, [rfReplaceAll]));
  {$ENDIF}

  if Assigned(FResultList) then
    FResultList.Free;

  inherited;
end;

procedure TTMSFNCWXCustomOCR.DoControlInitialized;
begin
  inherited;
  {$IFDEF WEBLIB}
  if not Assigned(VSIDE) then
  {$ENDIF}
  ExecuteJavascript(StringReplace(Format(INITWORKER, [IntToStr(FWorkerCount), FLanguage]), CONTROL_ID, GetControlID, [rfReplaceAll]));
end;

procedure TTMSFNCWXCustomOCR.LoadLinks(AList: TTMSFNCCustomWEBControlLinksList);
begin
  inherited;
  AList.Add(TTMSFNCCustomWEBControlLink.CreateScript(TESSERACTJS));
end;

procedure TTMSFNCWXCustomOCR.Notification(AComponent: TComponent;
  Operation: TOperation);
begin
  if (Operation = opRemove) and (AComponent.ClassType = TTMSFNCWXOCRHelper) then
  begin
    if (AComponent as TTMSFNCWXOCRHelper).OCR = Self then
      FOnFinishOCRInternal := nil;

  end;

  inherited;
end;

procedure TTMSFNCWXCustomOCR.ParseToLineArray(AList: TTMSFNCWXOCRLineList; const Value: TJSONArray);
var
  l: TTMSFNCWXOCRLine;
  j: TJSONValue;
  i: Integer;
begin
  for I := 0 to Value.Count -1 do
  begin
    l := TTMSFNCWXOCRLine.Create;
    j := TTMSFNCUtils.GetJSONValue(Value.Items[i],'bbox');
    l.Text := TTMSFNCUtils.GetJSONProp(Value.Items[i], 'text');
    l.Confidence := TTMSFNCUtils.GetJSONDoubleValue(Value.Items[i], 'confidence');
    l.Bbox.x0 := TTMSFNCUtils.GetJSONIntegerValue(j, 'x0');
    l.Bbox.x1 := TTMSFNCUtils.GetJSONIntegerValue(j, 'x1');
    l.Bbox.y0 := TTMSFNCUtils.GetJSONIntegerValue(j, 'y0');
    l.Bbox.y1 := TTMSFNCUtils.GetJSONIntegerValue(j, 'y1');
    ParseToWordArray(l.Words, TJSONArray(TTMSFNCUtils.GetJSONValue(Value.Items[i], 'words')));
    AList.Add(l);
  end;
end;

procedure TTMSFNCWXCustomOCR.ParseToParagraphArray(AList: TTMSFNCWXOCRParagraphList; const Value: TJSONArray);
var
  p: TTMSFNCWXOCRParagraph;
  j: TJSONValue;
  i: Integer;
begin
  for i := 0 to Value.Count -1 do
  begin
    j := TTMSFNCUtils.GetJSONValue(Value.Items[i],'bbox');
    p := TTMSFNCWXOCRParagraph.Create;
    p.Text := TTMSFNCUtils.GetJSONProp(Value.Items[i], 'text');
    p.Confidence := TTMSFNCUtils.GetJSONDoubleValue(Value.Items[i], 'confidence');
    p.Bbox.x0 := TTMSFNCUtils.GetJSONIntegerValue(j, 'x0');
    p.Bbox.x1 := TTMSFNCUtils.GetJSONIntegerValue(j, 'x1');
    p.Bbox.y0 := TTMSFNCUtils.GetJSONIntegerValue(j, 'y0');
    p.Bbox.y1 := TTMSFNCUtils.GetJSONIntegerValue(j, 'y1');
    ParseToLineArray(p.Lines, TJSONArray(TTMSFNCUtils.GetJSONValue(Value.Items[i], 'lines')));
    AList.Add(p);
  end;
end;

procedure TTMSFNCWXCustomOCR.ParseToWordArray(AList: TTMSFNCWXOCRWordList; const Value: TJSONArray);
var
  w: TTMSFNCWXOCRWord;
  j: TJSONValue;
  i: Integer;
begin
  for i := 0 to Value.Count -1 do
  begin
    j := TTMSFNCUtils.GetJSONValue(Value.Items[i],'bbox');
    w := TTMSFNCWXOCRWord.Create;
    w.Text := TTMSFNCUtils.GetJSONProp(Value.Items[i], 'text');
    w.Confidence := TTMSFNCUtils.GetJSONDoubleValue(Value.Items[i], 'confidence');
    w.Bbox.x0 := TTMSFNCUtils.GetJSONIntegerValue(j, 'x0');
    w.Bbox.x1 := TTMSFNCUtils.GetJSONIntegerValue(j, 'x1');
    w.Bbox.y0 := TTMSFNCUtils.GetJSONIntegerValue(j, 'y0');
    w.Bbox.y1 := TTMSFNCUtils.GetJSONIntegerValue(j, 'y1');
    AList.Add(w);
  end;
end;

procedure TTMSFNCWXCustomOCR.SetLanguage(const Value: string);
begin
  if Value <> FLanguage then
  begin
    Flanguage := Value;
    Terminate;
  end;

end;

procedure TTMSFNCWXCustomOCR.SetWorkerCount(const Value: Integer);
begin
  if (Value < 1) OR (Value > 20) then
    exit;

  if Value <> FWorkerCount then
  begin
    FWorkerCount := Value;
    Terminate;
  end;
end;

procedure TTMSFNCWXCustomOCR.Terminate;
begin
  ExecuteJavascript(StringReplace(TERMINATEOCR, CONTROL_ID, GetControlID, [rfReplaceAll]));
  ExecuteJavascript(StringReplace(Format(INITWORKER, [IntToStr(FWorkerCount), FLanguage]), CONTROL_ID, GetControlID, [rfReplaceAll]));
end;

{ TResult }

constructor TTMSFNCWXOCRResult.Create;
begin
  FLines := TTMSFNCWXOCRLineList.Create;
  FWords := TTMSFNCWXOCRWordList.Create;
  FParagraphs := TTMSFNCWXOCRParagraphList.Create;
end;

destructor TTMSFNCWXOCRResult.Destroy;
begin
  FWords.Free;
  FLines.Free;
  FParagraphs.Free;
  inherited;
end;

{ TParagraph }

constructor TTMSFNCWXOCRParagraph.Create;
begin
  FLines := TTMSFNCWXOCRLineList.Create;
  FBbox := TTMSFNCWXOCRBbox.Create;
end;

destructor TTMSFNCWXOCRParagraph.Destroy;
begin
  FLines.Free;
  FBbox.Free;
  inherited;
end;

{ TLine }

constructor TTMSFNCWXOCRLine.Create;
begin
  FWords := TTMSFNCWXOCRWordList.Create;
  FBbox := TTMSFNCWXOCRBbox.Create;
end;

destructor TTMSFNCWXOCRLine.Destroy;
begin
  FWords.Free;
  FBbox.free;
  inherited;
end;

{ TWord }

constructor TTMSFNCWXOCRWord.Create;
begin
  FBbox := TTMSFNCWXOCRBbox.Create;
end;

destructor TTMSFNCWXOCRWord.Destroy;
begin
  FBbox.Free;
  inherited;
end;


end.
